import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-white dark:bg-gray-900">
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8 text-center text-primary">{t('about.title')}</h1>

          {/* Story blocks */}
          <div className="space-y-8 mb-12">
            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t('about.story.whoTitle')}</h2>
              <p className="text-gray-600 dark:text-gray-300">{t('about.story.whoText')}</p>
            </div>

            {/* First placeholder image */}
            <div className="flex justify-center">
              <img src="/Images/about/placeholder-1.svg" alt="About placeholder" className="w-full max-w-2xl rounded-lg shadow-sm" />
            </div>

            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t('about.story.defineTitle')}</h2>
              <ul className="space-y-2 text-gray-600 dark:text-gray-300">
                {t('about.story.defineItems', { returnObjects: true }).map((item, idx) => (
                  <li key={idx}>• {item}</li>
                ))}
              </ul>
            </div>

            {/* Second placeholder image */}
            <div className="flex justify-center">
              <img src="/Images/about/placeholder-2.svg" alt="About placeholder" className="w-full max-w-2xl rounded-lg shadow-sm" />
            </div>

            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t('about.story.nameTitle')}</h2>
              <p className="text-gray-600 dark:text-gray-300">{t('about.story.nameText')}</p>
            </div>

            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t('about.story.missionTitle')}</h2>
              <p className="text-gray-600 dark:text-gray-300">{t('about.story.missionText')}</p>
            </div>
          </div>

          {/* The research results card was removed */}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
